// extracted by mini-css-extract-plugin
export var carrierTab = "_3x-0";
export var carrierTabActive = "_3x-1 _3x-0";
export var carrierTabInactive = "_3x-2 _3x-0";
export var carrierTabLabel = "_3x-3";
export var carrierTabLabelActive = "_3x-4 _3x-3";
export var carrierTabLabelInactive = "_3x-5 _3x-3";
export var carrierTabPercentage = "_3x-6";
export var carrierTabPercentageActive = "_3x-7 _3x-6";
export var carrierTabPercentageInactive = "_3x-8 _3x-6";
export var carrierTabWinnable = "_3x-9";
export var carrierTabWinnableActive = "_3x-a _3x-9";
export var carrierTabWinnableInactive = "_3x-b _3x-9";
export var comparisonContainer = "_3x-d";
export var missingRateButton = "_3x-n";
export var missingRateButtonActive = "_3x-o _3x-n";
export var missingRateButtonInactive = "_3x-p _3x-n";
export var missingRateButtonLabel = "_3x-q";
export var missingRateButtonLabelActive = "_3x-r _3x-q";
export var missingRateButtonLabelInactive = "_3x-s _3x-q";
export var sidebar = "_3x-c";
export var strategyButton = "_3x-e";
export var strategyButtonActive = "_3x-f _3x-e";
export var strategyButtonDescription = "_3x-k";
export var strategyButtonDescriptionActive = "_3x-l _3x-k";
export var strategyButtonDescriptionInactive = "_3x-m _3x-k";
export var strategyButtonInactive = "_3x-g _3x-e";
export var strategyButtonLabel = "_3x-h";
export var strategyButtonLabelActive = "_3x-i _3x-h";
export var strategyButtonLabelInactive = "_3x-j _3x-h";
export var unitToggleButton = "_3x-t";
export var unitToggleButtonActive = "_3x-u _3x-t";
export var unitToggleButtonInactive = "_3x-v _3x-t";
export var unitToggleButtonLabel = "_3x-w";
export var unitToggleButtonLabelActive = "_3x-x _3x-w";
export var unitToggleButtonLabelInactive = "_3x-y _3x-w";